import _ from "lodash";
import {STEPS, ACTIONS} from "./constants";
import {getAssetInternalId} from "../../../../../../../CustomerDashboard/utils";
import {getListWithToggledItem} from "../../utils";


export function createInitialState(initialActiveAssets) {
  return {
    step: STEPS.MAIN,
    activeSource: null,
    activeSourceItem: null,
    selectedAssets: [],
    activeAssets: initialActiveAssets || [],
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case ACTIONS.SELECT_SOURCE:
      return {
        ...state,
        step: action.payload.step || STEPS.SOURCE_LIST,
        activeSource: action.payload.source,
        activeAssets: [],
      };

    case ACTIONS.SELECT_SOURCE_ITEM:
      return {
        ...state,
        activeSourceItem: action.payload,
        step: STEPS.SOURCE_INSTRUMENTS,
      };

    case ACTIONS.CONFIRM_ASSETS_SELECTION: {
      const {assets} = action.payload;
      const selectedAssetsCopy = [...state.selectedAssets];
      assets.forEach(asset => {
        const idx = _.findIndex(selectedAssetsCopy, a => getAssetInternalId(a) === getAssetInternalId(asset));
        if (idx === -1) {
          selectedAssetsCopy.push({...asset, selected: true});
        }
      });
      return {
        ...state,
        step: STEPS.MAIN,
        activeSource: null,
        activeSourceItem: null,
        selectedAssets: selectedAssetsCopy,
        activeAssets: [],
      };
    }

    case ACTIONS.TOGGLE_SELECTED_ASSET: {
      const asset = action.payload;
      const id = getAssetInternalId(asset);
      return {
        ...state,
        selectedAssets: state.selectedAssets.map(a =>
          getAssetInternalId(a) === id ? {...a, selected: !a.selected} : a
        ),
      };
    }

    case ACTIONS.SELECT_ALL_ASSETS: {
      return {
        ...state,
        selectedAssets: state.selectedAssets.map(a => ({...a, selected: action.payload})),
      };
    }

    case ACTIONS.TOGGLE_ASSET: {
      const asset = action.payload;
      const getId = asset.payment_id ? (a) => a.payment_id : getAssetInternalId;
      return {...state, activeAssets: getListWithToggledItem(state.activeAssets, asset, getId)};
    }

    case ACTIONS.SET_ACTIVE_ASSETS:
      return {...state, activeAssets: action.payload};

    case ACTIONS.SET_STEP:
      return {...state, step: action.payload};

    case ACTIONS.GO_BACK: {
      // From source instruments → source list
      if (state.step === STEPS.SOURCE_INSTRUMENTS) {
        return {...state, step: STEPS.SOURCE_LIST, activeSourceItem: null, activeAssets: []};
      }
      // PORTFOLIO, SOURCE_LIST, FILTERS → main
      return {
        ...state,
        step: STEPS.MAIN,
        activeSource: null,
        activeSourceItem: null,
        activeAssets: [],
      };
    }

    default:
      return state;
  }
}
